import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// Import components and pages
import AdminLogin from './pages/AdminLogin';
import ForgotPassword from './pages/ForgotPassword';
import StudentForgotPassword from './pages/StudentForgotPassword';
import Dashboard from './pages/Dashboard';
import AddStudent from './components/AddStudent';
import CompletedTests from './pages/CompletedTests';
import StudentQuiz from './pages/StudentQuiz';
import StudentLogin from './pages/StudentLogin';
import StudentRegister from './pages/StudentRegister';
import StudentDashboard from './pages/StudentDashboard';
import StudentMark from './pages/StudentMarkDashboard';
import ResultPieChart from './pages/ResultPieChart';
import Result from './pages/Result';
import ProtectedStudentRoute from './components/ProtectedStudentRoute';
import QuestionTable from './pages/QuestionTable';
import StudentTestPage from './pages/StudentTestPage';
import StudentsList from './pages/StudentsList';
import BulkUploadQuestions from './pages/BulkUploadQuestions';
import Payment from './pages/Payment';
import StudentPayments from './pages/StudentPayments';
import StudentAccount from './pages/StudentAccount';
import GenerateTestPage from './pages/GenerateTestPage';
import TakeTestPage from './pages/TakeTestPage';
import TestResultPage from './pages/TestResultPage';
import AdminResultPage from './pages/AdminResultPage';
import AdminCompletedTestsPage from "./pages/AdminCompletedTestsPage";
import AddNewSection from './pages/AddNewSection';



function App() {
  return (
    <Router>
      <div className="app-container">

        {/* 🔒 Admin Routes */}
        <Routes>
          <Route path="/" element={<Navigate to="/admin-login" />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/questions" element={<QuestionTable />} />
          <Route path="/add-student" element={<AddStudent />} />
          <Route path="/quiz" element={<StudentQuiz />} />
          <Route path="/add" element={<BulkUploadQuestions />} />
          <Route path="/students-list" element={<StudentsList />} />
          <Route path="/Payment-admin" element={<Payment/>} />
          <Route path="/AdminResultPage" element={<AdminResultPage />} />
          <Route path="/all-completed-Tests" element={<AdminCompletedTestsPage />} />
          <Route path="/add-section" element={<AddNewSection />} />
          
          

          {/* 👤 Student Public Routes */}
          <Route path="/student-login" element={<StudentLogin />} />
          <Route path="/register" element={<StudentRegister />} />
          <Route path="/student-forgot-password" element={<StudentForgotPassword />} />

          {/* 🔐 Protected Student Routes */}
          <Route path="/student-dashboard" element={<ProtectedStudentRoute><StudentDashboard /></ProtectedStudentRoute>} />
          <Route path="/completed-tests" element={<ProtectedStudentRoute><CompletedTests /></ProtectedStudentRoute>} />
          <Route path="/result" element={<ProtectedStudentRoute><Result /></ProtectedStudentRoute>} />
          <Route path="/studentmark-dashboard" element={<ProtectedStudentRoute><StudentMark /></ProtectedStudentRoute>} />
          <Route path="/result-summary" element={<ProtectedStudentRoute><ResultPieChart /></ProtectedStudentRoute>} />
          <Route path="/Payment-student" element={<StudentPayments />} />
          <Route path="/generate-test" element={<GenerateTestPage />} />
          <Route path="/take-test/:testId" element={<TakeTestPage />} />
          <Route path="/test-result" element={<TestResultPage />} />
          <Route path="/profile" element={<StudentAccount />} />

          
          {/* 📝 Test Pages */}
          <Route path="/student/test/:testId" element={<ProtectedStudentRoute><StudentTestPage /></ProtectedStudentRoute>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;